export const savedTRFPrintScreenInitialState = {
    savedTRFDataAll: [],
    searchedTRFData: [],
    totalCount: 0,
    MoNumberValue: '',
    MoStatusValue: '',
    tagFlocFilter: [],
    tagMoFilter: [],
    tagFirstTestDoneByFilter: [],
    tagTestRecordIdFilter: [],
    tagTestRecordTestResultFilter: [],
    tagTestRecordAsFoundResultFilter: [],
    TagFirstDateTestedValue: null,
    DeckHullBldgValue: '',
    QuadValue: '',
    LevelValue: '',
    RoomValue: '',
    Location2Value: '',
    MonthValue: '',
    YearValue: '',
    selectedSavedTRFScreenFilters: {
        MoNumber: '',
        MoFunctionalLocation: '',
        TagFunctionalLocation: [],
        TagMO: [],
        TagFirstDateTested: '',
        TagFirstTestDoneBy: [],
        TagTestRecordId: [],
        DeckHullBldg: '',
        Quad: '',
        Level: '',
        Room: '',
        Location2: '',
        Month: '',
        Year: ''
    },
    sortMONumberAscOrder: true,
    sortTagFunctionalLocationAscOrder: true,
    sortTagDateTestedAscOrder: true,
    tableLoading: false
};
